import styled, { css } from 'react-emotion';
import controlIcons from '../VerticalDiagram/control-icons-100px.png';

export const Header = styled.div`
	font-size: 1.125rem;
	font-weight: bold;
	margin: 0.5rem 0 1rem;
	text-align: center;
`;

export const SmartTitle = styled.span`
	@media (min-width: 760px) {
		display: none;
	}
`;

export const ResultTitle = styled.span`
	@media (max-width: 759px) {
		text-transform: lowercase;
	}
`;

export const Title = styled.span`
	@media (max-width: 525px) {
		display: block;
		margin-bottom: 0.5rem;
	}
`;

export const AreaName = styled.span`
	text-align: center;
	margin-left: 0.5rem;

	@media (max-width: 525px) {
		margin-left: 0rem;
	}
`;

export const FlexContent = styled.div`
	display: flex;
	padding: 0 1rem;
	
	@media (max-width: 480px) {
		padding: 0 0.5rem;
	}
`;

export const ArrowCommon = css`
	background-image: url('${controlIcons}');
	background-repeat: no-repeat;
	display: block;
	height: 100px;
	width: 34px;
	cursor: pointer;
`;

export const ArrowPrev = styled.span`
	background-position: 0 0;

	&:hover {
		background-position: 0 -220px;
	}
`;

export const ArrowNext = styled.span`
	margin-left: auto;
	background-position: 0 -110px;

	&:hover {
		background-position: 0 -330px;
	}
`;

export const Totals = styled.span`
	font-size: 0.9rem;
	font-weight: normal;
	margin-left: 1rem;
`;

export const Participation = styled.span`
	font-size: 0.9rem;
	font-weight: normal;
	margin-left: 1rem;
`;
